import React from "react";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Title,
  LineElement,
  PointElement,
  BarController,
  LineController,
} from "chart.js";
import { Col, Container, Row } from "reactstrap";
import { Chart } from "react-chartjs-2";
import { formatCustomDate } from "../../../utils/dateformatter";
import { customAxisPlugin } from "./customAxisPlugin";

ChartJS.register(
  BarElement,
  Title,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  BarController,
  LineController,
  Tooltip,
  Legend
);

const DataChart = ({
  datasetType = "yakuba",
  jsonData,
  request_Date,
  forecast_datetime,
}) => {
  const chartSource = jsonData;
  const labels = chartSource?.time;
  const forecast_Datetime = formatCustomDate(forecast_datetime);

  const chartData = {
    labels,
    datasets: [
      {
        type: "bar",
        label:
          datasetType === "yakuba" ? "発電予測量(kWh)屋上" : "発電予測量(kWh)",
        data:
          datasetType === "yakuba"
            ? chartSource?.rooftop_gen
            : chartSource?.generation,
        backgroundColor: "#489d2e",
        yAxisID: "y",
      },
      ...(datasetType === "yakuba"
        ? [
            {
              type: "bar",
              label: "発電予測量(kWh)カーポート",
              data: chartSource?.carpot_gen,
              backgroundColor: "#367223",
              yAxisID: "y",
            },
          ]
        : []),
      {
        type: "bar",
        label: "需要予測量(kWh)",
        data:
          datasetType === "yakuba"
            ? chartSource?.demand
            : chartSource?.total_demand,
        backgroundColor: "#e47331",
        yAxisID: "y",
      },
      {
        type: "line",
        label: "購入予測量(kWh)",
        data: chartSource?.purchase,
        borderColor: "red",
        borderWidth: 2,
        tension: 0.1,
        yAxisID: "y",
        pointRadius: 0,
        pointHoverRadius: 5,
      },

      ...(datasetType === "yakuba"
        ? [
            {
              type: "line",
              label: "購入電力量(kWh)",
              data: chartSource?.purchase_r,
              borderColor: "#E97451",
              borderWidth: 2,
              tension: 0.1,
              yAxisID: "y",
              pointRadius: 0,
              pointHoverRadius: 5,
            },
          ]
        : []),

      {
        type: "line",
        label: "日射量(kWh/m²)",
        data: chartSource?.radiation,
        borderColor: "#fdba25",
        borderWidth: 2,
        tension: 0.1,
        yAxisID: "y1",
        pointRadius: 0,
        pointHoverRadius: 5,
      },
      {
        type: "line",
        label: "蓄電池SOC(%)",
        data: chartSource?.soc,
        borderColor: "#00BCD4",
        borderWidth: 2,
        tension: 0.1,
        yAxisID: "y2",
        pointRadius: 0,
        pointHoverRadius: 5,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: { mode: "index", intersect: false },
    plugins: {
      title: {
        display: true,
        text: `${request_Date} \u00A0\u00A0\u00A0 (予測日時: ${forecast_Datetime}) \u00A0\u00A0\u00A0 ${
          datasetType === "yakuba" ? "釧路町役場" : datasetType === "hirono" ? "広野町" : "マイクログリッド"
        } `,
        color: "#fff",
        font: {
          size: 14,
          weight: "bold",
        },
      },
      legend: {
        position: "bottom",
        labels: {
          color: "#fff",
          font: {
            size: 10,
          },
        },
      },

      tooltip: { enabled: true },
    },

    scales: {
      x: {
        ticks: {
          color: "#fff",
          maxRotation: 0,
          minRotation: 0,
          font: {
            size: 8,
          },
        },

        grid: {
          display: false,
          drawBorder: true,
        },
      },
      y: {
        type: "linear",
        display: true,
        position: "left",
        ticks: {
          color: "#fff",
          padding: 5,
          font: {
            size: 10,
          },
          stepSize: 5,
        },
        title: {
          display: false,
          text: "kWh",
        },
        grid: { color: "rgba(255,255,255,0.05)" },
      },
      y1: {
        type: "linear",
        display: true,
        position: "right",
        offset: true,
        weight: 1,
        ticks: {
          color: "#fff",
          font: {
            size: 10,
          },
          stepSize: 0.1,
          padding: 10,
        },
        title: {
          display: false,
          text: "kWh/m²",
        },
        grid: { drawOnChartArea: false },
      },
      y2: {
        type: "linear",
        display: true,
        position: "right",
        offset: true,
        weight: 2,
        min: 0,
        max: 100,
        ticks: {
          color: "#fff",
          font: {
            size: 10,
          },
          stepSize: 5,
          padding: 14,
        },
        title: {
          display: false,
          text: "SOC",
        },

        grid: { drawOnChartArea: false },
      },
    },
  };

  return (
    <Container fluid className="px-5 mt-3">
      <Row>
        <Col md={12}>
          <div
            style={{
              backgroundColor: "#3B3B3B",
              paddingTop: "10px",
              paddingBottom: "23px",
              paddingRight: "5px",
              paddingLeft: "5px",
              height: "325px",
              width: " 100%",
            }}
          >
            <Chart
              id="myChartCanvas"
              type="bar"
              data={chartData}
              options={{ ...options, maintainAspectRatio: false }}
              plugins={[customAxisPlugin]}
            />
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default DataChart;
